import React, { useState } from 'react';
import Accordion from 'devextreme-react/accordion';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faHourglassHalf } from '@fortawesome/free-solid-svg-icons';

function AccordionGroup(props) {
  const { key, data, setSelectedItems } = props;

  // function onItemsChange (e){
  //   console.log("onItemsChange", e)
  // }

  return (
    <Accordion
      key={key}
      dataSource={data}
      collapsible
      multiple
      selectedItems={setSelectedItems != null && setSelectedItems === true ? data : []}
      // onSelectedItemsChange={onItemsChange}
      itemTitleRender={(data) => {
        return (
          <>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#3B5158', marginRight: 15 }}>
              {data.quotationId
              ? (data.financeId ? `Simulação de Financiamento #${data.financeId}` : `Cotação para Montadora: ${data.brandName}`)
              : `${data.title}`}
            </span>
            {data.replied !== undefined && data.replied === false && <FontAwesomeIcon style={{ color: '#800000' }} icon={faHourglassHalf} />}
            {data.replied !== undefined && data.replied === true && <FontAwesomeIcon style={{ color: '#008000' }} icon={faCheck} />}
          </>
        );
      }}
      itemRender={(data,i) => {
        return <div key={i} className="grid-contract">{data.body}</div>;
      }}
    />
  );
}

export { AccordionGroup };
